import React, { createContext, useContext } from 'react';
import type { Translations } from '../locales/types';
import en from '../locales/en';

const TranslationContext = createContext<Translations>(en);

export const TranslationProvider: React.FC<{
  value: Translations;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <TranslationContext.Provider value={value}>{children}</TranslationContext.Provider>
);

export const useTranslation = (): Translations => useContext(TranslationContext);
